import { buildTask as _buildTask } from "ember-concurrency/async-arrow-runtime";
var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _dec18, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21, _descriptor22, _descriptor23, _AlertTriggeredJournalEvent;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { attr, belongsTo, hasMany } from "@ember-data/model";
import { assert } from "@ember/debug";
import { service } from "@ember/service";
import AlertOngoingJournalEvent from "core/models/alert-ongoing-journal-event";
import AlertProcessedJournalEvent from "core/models/alert-processed-journal-event";
import CommentWrittenJournalEvent from "core/models/comment-written-journal-event";
import JournalEvent from "core/models/journal-event";
import Patient from "core/models/patient";
import ParogService from "core/services/parog";
import SemeiaSessionService from "core/services/session";
import { isClinicalForgetAlert, isMrcStageChangealert, isOfComputedType, isTlsPrescriptionAlert, tlsPrescriptionTrigger } from "core/utils/alert";
import tWithDefault from "core/utils/t-with-default";
import dayjs from "dayjs";
import { validateDate, validateInclusion, validatePresence } from "ember-changeset-validations/validators";
import FlashMessagesService from "ember-cli-flash/services/flash-messages";
import { task } from "ember-concurrency";
import Store from "ember-data/store";
import IntlService from "ember-intl/services/intl";
import MrcStageEvaluatedJournalEvent from "./mrc-stage-evaluated-journal-event";

/** A ComputedAlertType is based on the combination of several alert's attributes */

//---- Automatically generated, don't update this part ----
let AlertTriggeredJournalEvent = (_dec = attr("string"), _dec2 = attr("string"), _dec3 = attr("string"), _dec4 = attr("string"), _dec5 = attr(), _dec6 = attr("string"), _dec7 = attr(), _dec8 = attr("string"), _dec9 = attr("string"), _dec10 = attr("string"), _dec11 = attr("date"), _dec12 = belongsTo("alert-processed-journal-event", {
  async: false,
  inverse: "alertTriggeredJournalEvent"
}), _dec13 = belongsTo("alert-ongoing-journal-event", {
  async: false,
  inverse: "alertTriggeredJournalEvent"
}), _dec14 = hasMany("comment-written-journal-event", {
  async: false,
  inverse: "alertTriggeredJournalEvent"
}), _dec15 = belongsTo("mrc-stage-evaluated-journal-event", {
  async: false,
  inverse: "alertTriggeredJournalEvent"
}), _dec16 = belongsTo("journal-event", {
  async: false,
  inverse: "alertTriggeredJournalEvents",
  polymorphic: true,
  as: "journal-event"
}), _dec17 = belongsTo("tls-prescribed-journal-event", {
  async: false,
  inverse: "alertTriggeredJournalEvent"
}), _dec18 = belongsTo("patient", {
  async: false,
  inverse: "alertTriggeredJournalEvents"
}), _class = (_AlertTriggeredJournalEvent = class AlertTriggeredJournalEvent extends JournalEvent {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "alertType", _descriptor, this);
    _initializerDefineProperty(this, "subType", _descriptor2, this);
    _initializerDefineProperty(this, "source", _descriptor3, this);
    /**
     * At the moment, let's fetch the localized description of the alert
     * triggered JE from the API. If, at some point, we manage to compute this
     * descritpion on the front side, then we will remove this attr.
     *
     * FIXME: this is a legacy attribute, maybe not used anymore. We may remove
     * it.
     */
    _initializerDefineProperty(this, "frLocalizedDescription", _descriptor4, this);
    /**
     * Trigger - A "Trigger" is an object which describes why the rule has been
     * triggered.
     *
     * He must provides two keys :
     * @attr [string] key
     * @attr [string] type
     *
     * @example Create an OutOfRangeTrigger
     * {
     *   key: "blood-pressure-pas",
     *   type: "out-of-range",
     *   min: 110,
     *   max: 160,
     *   value: 100
     * }
     */
    _initializerDefineProperty(this, "triggers", _descriptor5, this);
    _initializerDefineProperty(this, "reasonKey", _descriptor6, this);
    /**
     * the alert object that come from the payload from the Alertor
     */
    _initializerDefineProperty(this, "rawOmop", _descriptor7, this);
    /**
     * criticality of the alert;
     */
    _initializerDefineProperty(this, "criticality", _descriptor8, this);
    _initializerDefineProperty(this, "triggeringJournalEventId", _descriptor9, this);
    _initializerDefineProperty(this, "triggeringJournalEventType", _descriptor10, this);
    _initializerDefineProperty(this, "triggeringJournalEventOccurredAt", _descriptor11, this);
    _initializerDefineProperty(this, "alertProcessedJournalEvent", _descriptor12, this);
    _initializerDefineProperty(this, "alertOngoingJournalEvent", _descriptor13, this);
    _initializerDefineProperty(this, "commentWrittenJournalEvents", _descriptor14, this);
    _initializerDefineProperty(this, "mrcStageEvaluatedJournalEvent", _descriptor15, this);
    //---- End of generated code ----
    _initializerDefineProperty(this, "flashMessages", _descriptor16, this);
    _initializerDefineProperty(this, "intl", _descriptor17, this);
    _initializerDefineProperty(this, "parog", _descriptor18, this);
    _initializerDefineProperty(this, "session", _descriptor19, this);
    _initializerDefineProperty(this, "store", _descriptor20, this);
    _initializerDefineProperty(this, "triggeringJournalEvent", _descriptor21, this);
    _initializerDefineProperty(this, "tlsPrescribedJournalEvent", _descriptor22, this);
    _initializerDefineProperty(this, "patient", _descriptor23, this);
    _defineProperty(this, "prescribeRemoteMonitoringTask", _buildTask(() => ({
      context: this,
      generator: function* () {
        if (this.isTlsPrescriptionAlert) {
          return this.prescribeTls();
        }
        throw new Error(`The alert '${this.id}' is not a remote monitoring alert`);
      }
    }), null, "prescribeRemoteMonitoringTask", null));
  }
  static validations(intl) {
    return {
      alertType: [validatePresence({
        presence: true,
        description: intl.t("validations.alert-triggered-journal-event.alert-type")
      }), validateInclusion({
        list: ["biological", "clinical", "journey", "non_calculable", "mrc-stage-change-4", "mrc-stage-change-5", "treatment-compliance"],
        description: intl.t("validations.alert-triggered-journal-event.alert-type")
      })],
      occurredAt: [validatePresence({
        presence: true,
        description: tWithDefault(intl, "validations.alert-triggered-journal-event.occurred-at", "La date")
      }), validateDate({
        message: "Cette donnée ne peut être déclarée avant 1900. Veuillez modifier la date",
        onOrAfter: new Date("01/01/1900")
      }), validateDate({
        message: "Cette donnée ne peut être déclarée dans le futur. Veuillez modifier la date",
        onOrBefore: dayjs().endOf("day").toDate()
      })],
      criticality: validateInclusion({
        list: ["high"],
        allowBlank: true,
        description: intl.t("validations.alert-triggered-journal-event.criticality")
      })
    };
  }
  get hasHistory() {
    const firstTrigger = this.triggers?.[0];
    const firstTriggerKey = firstTrigger?.key;
    const firstTriggerType = firstTrigger?.type;

    // is weight alert
    if (firstTriggerKey === "weight" && firstTriggerType == "out-of-range") return true;

    // is blood pressure alert
    if ((firstTriggerKey === "diastolic" || firstTriggerKey === "systolic") && firstTriggerType == "out-of-range") return true;

    // is biological alert
    if (this.alertType === "biological") return true;

    // is a survey alert
    if (["ctcae-filled-journal-event", "ctcae-custom-pre-treatment", "ctcae-custom-inter-treatment", "ctcae-custom-pre-surgery", "ctcae-custom-post-surgery", "anxiety", "rch", "crohn", "ibd-disk", "discharge-form"].includes(this.subType)) {
      return true;
    }
    return false;
  }
  get models() {
    const firstTrigger = this.triggers?.[0];
    const firstTriggerKey = firstTrigger?.key;
    const firstTriggerType = firstTrigger?.type;
    if (firstTriggerKey === "weight" && firstTriggerType == "out-of-range") {
      return {
        route: "dashboard.main.results-table.measurements"
      };
    } else if ((firstTriggerKey === "diastolic" || firstTriggerKey === "systolic") && firstTriggerType == "out-of-range") {
      return {
        route: "blood-pressure.sessions"
      };
    }
    if (this.subType == "anxiety") {
      return {
        feature: "anxiety",
        component: "summary"
      };
    }
    if (this.subType == "ctcae-custom-pre-treatment") {
      return {
        feature: "ctcae-custom",
        component: "pre-treatment-summary"
      };
    }
    if (this.subType == "ctcae-custom-inter-treatment") {
      return {
        feature: "ctcae-custom",
        component: "inter-treatment-summary"
      };
    }
    if (this.subType == "ctcae-custom-pre-surgery") {
      return {
        feature: "ctcae-custom",
        component: "pre-surgery-summary"
      };
    }
    if (this.subType == "ctcae-custom-post-surgery") {
      return {
        feature: "ctcae-custom",
        component: "post-surgery-summary"
      };
    }
    if (this.subType == "ctcae-filled-journal-event") {
      return {
        feature: "ctcae",
        component: "summary"
      };
    }
    if (this.subType == "rch") {
      return {
        feature: "mici",
        component: "rch-survey-summary"
      };
    }
    if (this.subType == "crohn") {
      return {
        feature: "mici",
        component: "crohn-survey-summary"
      };
    }
    if (this.subType == "ibd-disk") {
      return {
        feature: "mici",
        component: "ibd-disk-survey-summary"
      };
    }
    if (this.subType == "discharge-form") {
      return {
        feature: "diabetowise-discharge",
        component: "edition-form",
        sourceJeId: this.patient.diabetowiseDischargeCompletedJournalEvent?.id
      };
    }
    return {
      route: "dashboard.bio-results.summary"
    };
  }

  /**
   * The alert can target a JE that represents several values.
   * The code is extracted from the rawOmop value to designate the element that triggered the alert
   */
  get code() {
    return this.rawOmop ? this.rawOmop.variable : undefined;
  }

  /**
   * FIXME: this code should be moved out of the model. It should rather in the
   * component that needs this specific formatting, or in a helper if shared
   * between several components.
   *
   */
  get description() {
    const {
      alertType,
      subType
    } = this;
    let title = this.intl.t(`alert.alert-type.${alertType}`);
    if (alertType === "clinical") {
      if (subType && subType.length > 0) {
        title = this.intl.t(`alert.sub-type.${alertType}.${subType}`);
      }
    }
    return title;
  }
  get isUnprocessed() {
    return this.alertProcessedJournalEvent == null;
  }
  get hasBeenProcessed() {
    return !this.isUnprocessed;
  }

  /** Is there an alertOngoingJournalEvent non archived attached to the alert */
  get isProcessing() {
    const ongoingJE = this.alertOngoingJournalEvent;
    return ongoingJE && !ongoingJE.isArchived;
  }

  /** Is this alert considered as "critical"? */
  get isCritical() {
    return this.criticality === "high";
  }

  /**
   * Process this alert.
   *
   * This creates a alert-processed-journal-event linked to this event, and sets
   * actionTaken attribute to the given parameter.
   */
  async processAlert({
    actionTaken,
    comment
  }) {
    assert("actionTaken is mandatory", !!actionTaken);
    if (this.alertOngoingJournalEvent) {
      this.alertOngoingJournalEvent.unloadRecord();
    }
    const alertProcessedJournalEvent = this.store.createRecord("alert-processed-journal-event", {
      patient: this.patient,
      occurredAt: new Date(),
      alertTriggeredJournalEvent: this.store.peekRecord("alert-triggered-journal-event", this.id),
      actionTaken,
      comment
    });
    try {
      return await alertProcessedJournalEvent.save();
    } catch {
      alertProcessedJournalEvent.unloadRecord();
      return false;
    }
  }
  get isTlsPrescriptionAlert() {
    return isTlsPrescriptionAlert(this);
  }
  get isBioExamPrescriptionAlert() {
    return isOfComputedType(this, "bio-exam-prescription");
  }
  get isMrcStageChangealert() {
    return isMrcStageChangealert(this);
  }
  get isMiciSurveyAlert() {
    return isOfComputedType(this, "mici-survey");
  }
  get isMedicationPrescriptionAlert() {
    return isOfComputedType(this, "medication-prescription");
  }
  get isTlsRenewal() {
    return this.triggeringJournalEventType === "TlsPrescribedJournalEvent";
  }
  get isClinicalForgetAlert() {
    return isClinicalForgetAlert(this);
  }
  async prescribeTls() {
    if (!this.isTlsPrescriptionAlert) {
      throw new Error(`Impossible to prescribe a TLS prescription for the non-tls alert '${this.id}'.`);
    }
    return this.store.createRecord("tls-prescribed-journal-event", {
      patient: this.patient,
      occurredAt: new Date(),
      startDate: new Date(tlsPrescriptionTrigger(this).nextPrescriptionStartDate),
      alertTriggeredJournalEvent: this
    }).save();
  }
}, _defineProperty(_AlertTriggeredJournalEvent, "type", "alert-triggered-journal-event"), _AlertTriggeredJournalEvent), _descriptor = _applyDecoratedDescriptor(_class.prototype, "alertType", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "subType", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "source", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "frLocalizedDescription", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "triggers", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "reasonKey", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "rawOmop", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "criticality", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "triggeringJournalEventId", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "triggeringJournalEventType", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "triggeringJournalEventOccurredAt", [_dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "alertProcessedJournalEvent", [_dec12], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "alertOngoingJournalEvent", [_dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "commentWrittenJournalEvents", [_dec14], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "mrcStageEvaluatedJournalEvent", [_dec15], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "flashMessages", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, "parog", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor19 = _applyDecoratedDescriptor(_class.prototype, "session", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor20 = _applyDecoratedDescriptor(_class.prototype, "store", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor21 = _applyDecoratedDescriptor(_class.prototype, "triggeringJournalEvent", [_dec16], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor22 = _applyDecoratedDescriptor(_class.prototype, "tlsPrescribedJournalEvent", [_dec17], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor23 = _applyDecoratedDescriptor(_class.prototype, "patient", [_dec18], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { AlertTriggeredJournalEvent as default }; // DO NOT DELETE: this is how TypeScript knows how to look up your models.